import React from 'react';
import { motion } from 'framer-motion';
import { TransactionTimeline as TransactionTimelineType } from '../../../utils/types';
import { TransactionData } from '../utils/transactionUtils';
import { TransactionStatus } from './TransactionStatus';
import { TransactionTimeline } from './TransactionTimeline';
import { TransactionSummary } from './TransactionSummary';
import { EllipseIcon } from './icons';
import { CancelPendingTransactionAction } from '../../../components/CancelPendingTransactionAction';
import { FailureReasonBox } from '../../../components/FailureReasonBox';

interface TransactionDetailsProps {
  transaction: TransactionData | null;
  timeline: TransactionTimelineType | undefined;
  timelineLoading: boolean;
  onTransactionCancelled?: () => void;
}

export const TransactionDetails: React.FC<TransactionDetailsProps> = ({
  transaction,
  timeline,
  timelineLoading,
  onTransactionCancelled,
}) => {
  if (!transaction) return null;

  return (
    <div className='flex-[3] p-4 overflow-y-auto h-full relative'>
      <div className='absolute right-0 top-20 z-0'>
        <EllipseIcon />
      </div>

      <motion.div
        key={transaction.transactionId}
        initial={{ y: 50, opacity: 0.5 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 70, damping: 20 }}
        className='flex flex-col py-8 px-12 gap-10'
      >
        <div className='relative'>
          <div className='absolute bottom-1 left-1/2 translate-x-[-50%] w-[80%] h-[60px] rounded-[20px] shadow-[0px_12px_50px_0px_#A6B1CB] z-0 pointer-events-none'></div>
          <div className='relative z-5 flex flex-col px-[20px] py-[24px] items-start rounded-[20px] border border-[#E9EDF9] bg-[#F9FAFC] gap-6'>
            <TransactionStatus transaction={transaction} />
            {transaction.status?.toLowerCase() === 'failed' && (
              <FailureReasonBox
                message={
                  transaction.formattedErrorMessage || transaction.errorMessages
                }
              />
            )}
            <TransactionTimeline
              timeline={timeline}
              transaction={transaction}
              isLoading={timelineLoading}
            />
          </div>
        </div>

        <TransactionSummary transaction={transaction} />

        <CancelPendingTransactionAction
          tenantTransactionId={transaction.transactionId}
          status={transaction.status}
          onCancelled={onTransactionCancelled}
        />
      </motion.div>
    </div>
  );
};

